import React from 'react';
import {
  ArrowBendUpRightIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpRightIcon,
  ArrowsClockwiseIcon,
  ArticleIcon,
  BellIcon,
  BookOpenIcon,
  BrainIcon,
  BriefcaseIcon,
  BroadcastIcon,
  BugIcon,
  BuildingsIcon,
  CalculatorIcon,
  CalendarBlankIcon,
  ChartBarIcon,
  ChartLineDownIcon,
  ChartLineUpIcon,
  ChatCircleDotsIcon,
  ChatsIcon,
  CheckCircleIcon,
  CircleIcon,
  ClipboardTextIcon,
  ClockIcon,
  CodeIcon,
  CoffeeIcon,
  CompassIcon,
  ConfettiIcon,
  CrownIcon,
  CubeIcon,
  DesktopIcon,
  DeviceMobileIcon,
  DeviceTabletIcon,
  DiamondIcon,
  DiceFiveIcon,
  DnaIcon,
  EnvelopeIcon,
  EnvelopeOpenIcon,
  EyeIcon,
  EyeSlashIcon,
  FadersIcon,
  FeatherIcon,
  FileIcon,
  FileTextIcon,
  FileZipIcon,
  FilesIcon,
  FilmStripIcon,
  FlagCheckeredIcon,
  FloppyDiskIcon,
  FloppyDiskBackIcon,
  FolderIcon,
  FolderOpenIcon,
  GearSixIcon,
  GitBranchIcon,
  GlobeIcon,
  GraduationCapIcon,
  HandshakeIcon,
  HardDrivesIcon,
  HashIcon,
  HeartIcon,
  HourglassIcon,
  HouseIcon,
  ImageIcon,
  ImagesIcon,
  InfoIcon,
  KeyIcon,
  LaptopIcon,
  LifebuoyIcon,
  LightbulbIcon,
  LightningIcon,
  LinkIcon,
  ListChecksIcon,
  LockIcon,
  LockKeyIcon,
  LockOpenIcon,
  MagnifyingGlassIcon,
  MapPinIcon,
  MegaphoneIcon,
  MicrophoneIcon,
  MicroscopeIcon,
  MinusIcon,
  MouseIcon,
  MusicNotesIcon,
  PaletteIcon,
  PaperclipIcon,
  PencilSimpleIcon,
  PhoneIcon,
  PlayIcon,
  PlusIcon,
  ProhibitIcon,
  PushPinIcon,
  PuzzlePieceIcon,
  QuestionIcon,
  RobotIcon,
  RocketIcon,
  RulerIcon,
  ScalesIcon,
  ScissorsIcon,
  ShieldCheckIcon,
  SignOutIcon,
  SirenIcon,
  SlidersIcon,
  SmileyIcon,
  SparkleIcon,
  StarIcon,
  TagIcon,
  TargetIcon,
  TerminalIcon,
  TestTubeIcon,
  TextAaIcon,
  ThumbsUpIcon,
  TrashIcon,
  TrayIcon,
  TreeStructureIcon,
  TrophyIcon,
  UploadSimpleIcon,
  UserIcon,
  UsersIcon,
  WarningIcon,
  WrenchIcon,
  XIcon,
} from '@phosphor-icons/react/ssr';

function RobotArmIcon(props: React.SVGProps<SVGSVGElement> & { size?: number | string }) {
  return <svg data-ui-icon="RobotArm" className={props.className} width={props.size} height={props.size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden={props['aria-hidden']} aria-label={props['aria-label']} role={props.role} style={props.style}>
    <path d="M3 21h12l-1-3H4l-1 3ZM8 18v-3m3 3v-3M7 11 4.5 6.5m3-1.5 4 7M8 4.5l8.5 2m-.5 3L7 7M19 10v3m-2-6h3v3h-3zM17 13h4v3l-1.5 1m-2.5-4v3l1.5 1" />
    <circle cx="6" cy="5.5" r="2.2" /><circle cx="9.5" cy="13" r="2.4" />
  </svg>;
}

const icons = {
  ArrowBendUpRight: ArrowBendUpRightIcon,
  ArrowDown: ArrowDownIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  ArrowUpRight: ArrowUpRightIcon,
  ArrowsClockwise: ArrowsClockwiseIcon,
  Article: ArticleIcon,
  Bell: BellIcon,
  BookOpen: BookOpenIcon,
  Brain: BrainIcon,
  Briefcase: BriefcaseIcon,
  Broadcast: BroadcastIcon,
  Bug: BugIcon,
  Buildings: BuildingsIcon,
  Calculator: CalculatorIcon,
  CalendarBlank: CalendarBlankIcon,
  ChartBar: ChartBarIcon,
  ChartLineDown: ChartLineDownIcon,
  ChartLineUp: ChartLineUpIcon,
  ChatCircleDots: ChatCircleDotsIcon,
  Chats: ChatsIcon,
  CheckCircle: CheckCircleIcon,
  Circle: CircleIcon,
  ClipboardText: ClipboardTextIcon,
  Clock: ClockIcon,
  Code: CodeIcon,
  Coffee: CoffeeIcon,
  Compass: CompassIcon,
  Confetti: ConfettiIcon,
  Crown: CrownIcon,
  Cube: CubeIcon,
  Desktop: DesktopIcon,
  DeviceMobile: DeviceMobileIcon,
  DeviceTablet: DeviceTabletIcon,
  Diamond: DiamondIcon,
  DiceFive: DiceFiveIcon,
  Dna: DnaIcon,
  Envelope: EnvelopeIcon,
  EnvelopeOpen: EnvelopeOpenIcon,
  Eye: EyeIcon,
  EyeSlash: EyeSlashIcon,
  Faders: FadersIcon,
  Feather: FeatherIcon,
  File: FileIcon,
  FileText: FileTextIcon,
  FileZip: FileZipIcon,
  Files: FilesIcon,
  FilmStrip: FilmStripIcon,
  FlagCheckered: FlagCheckeredIcon,
  FloppyDisk: FloppyDiskIcon,
  FloppyDiskBack: FloppyDiskBackIcon,
  Folder: FolderIcon,
  FolderOpen: FolderOpenIcon,
  GearSix: GearSixIcon,
  GitBranch: GitBranchIcon,
  Globe: GlobeIcon,
  GraduationCap: GraduationCapIcon,
  Handshake: HandshakeIcon,
  HardDrives: HardDrivesIcon,
  Hash: HashIcon,
  Heart: HeartIcon,
  Hourglass: HourglassIcon,
  House: HouseIcon,
  Image: ImageIcon,
  Images: ImagesIcon,
  Info: InfoIcon,
  Key: KeyIcon,
  Laptop: LaptopIcon,
  Lifebuoy: LifebuoyIcon,
  Lightbulb: LightbulbIcon,
  Lightning: LightningIcon,
  Link: LinkIcon,
  ListChecks: ListChecksIcon,
  Lock: LockIcon,
  LockKey: LockKeyIcon,
  LockOpen: LockOpenIcon,
  MagnifyingGlass: MagnifyingGlassIcon,
  MapPin: MapPinIcon,
  Megaphone: MegaphoneIcon,
  Microphone: MicrophoneIcon,
  Microscope: MicroscopeIcon,
  Minus: MinusIcon,
  Mouse: MouseIcon,
  MusicNotes: MusicNotesIcon,
  Palette: PaletteIcon,
  Paperclip: PaperclipIcon,
  PencilSimple: PencilSimpleIcon,
  Phone: PhoneIcon,
  Play: PlayIcon,
  Plus: PlusIcon,
  Prohibit: ProhibitIcon,
  PushPin: PushPinIcon,
  PuzzlePiece: PuzzlePieceIcon,
  Question: QuestionIcon,
  Robot: RobotIcon,
  RobotArm: RobotArmIcon,
  Rocket: RocketIcon,
  Ruler: RulerIcon,
  Scales: ScalesIcon,
  Scissors: ScissorsIcon,
  ShieldCheck: ShieldCheckIcon,
  SignOut: SignOutIcon,
  Siren: SirenIcon,
  Sliders: SlidersIcon,
  Smiley: SmileyIcon,
  Sparkle: SparkleIcon,
  Star: StarIcon,
  Tag: TagIcon,
  Target: TargetIcon,
  Terminal: TerminalIcon,
  TestTube: TestTubeIcon,
  TextAa: TextAaIcon,
  ThumbsUp: ThumbsUpIcon,
  Trash: TrashIcon,
  Tray: TrayIcon,
  TreeStructure: TreeStructureIcon,
  Trophy: TrophyIcon,
  UploadSimple: UploadSimpleIcon,
  User: UserIcon,
  Users: UsersIcon,
  Warning: WarningIcon,
  Wrench: WrenchIcon,
  X: XIcon,
} as const;

// Старые метаданные блоков и шаблонов остаются строками: меняется только отображение.
const legacyNames: Record<string, keyof typeof icons> = {
  "📊": "ChartBar",
  "📈": "ChartLineUp",
  "📉": "ChartLineDown",
  "📰": "Article",
  "🚀": "Rocket",
  "🏛️": "Buildings",
  "🏛": "Buildings",
  "🏢": "Buildings",
  "👥": "Users",
  "👤": "User",
  "📅": "CalendarBlank",
  "🗓️": "CalendarBlank",
  "🗓": "CalendarBlank",
  "📁": "Folder",
  "📂": "FolderOpen",
  "💬": "ChatCircleDots",
  "💭": "ChatCircleDots",
  "🗨️": "Chats",
  "🗨": "Chats",
  "⚙️": "GearSix",
  "⚙": "GearSix",
  "🎨": "Palette",
  "💼": "Briefcase",
  "✏️": "PencilSimple",
  "✏": "PencilSimple",
  "📝": "PencilSimple",
  "📋": "ClipboardText",
  "⏳": "Hourglass",
  "⌛": "Hourglass",
  "🟢": "Circle",
  "🔴": "Circle",
  "🟡": "Circle",
  "🔵": "Circle",
  "⚪": "Circle",
  "⚫": "Circle",
  "🖥️": "Desktop",
  "🖥": "Desktop",
  "⚡": "Lightning",
  "📭": "EnvelopeOpen",
  "📧": "Envelope",
  "✉️": "Envelope",
  "✉": "Envelope",
  "📨": "Envelope",
  "📩": "Envelope",
  "📥": "Tray",
  "📤": "UploadSimple",
  "👁️": "Eye",
  "👁": "Eye",
  "🙈": "EyeSlash",
  "🏷️": "Tag",
  "🏷": "Tag",
  "➕": "Plus",
  "➖": "Minus",
  "💾": "FloppyDisk",
  "ℹ️": "Info",
  "ℹ": "Info",
  "🗑️": "Trash",
  "🗑": "Trash",
  "🛡️": "ShieldCheck",
  "🛡": "ShieldCheck",
  "🚫": "Prohibit",
  "⛔": "Prohibit",
  "🤝": "Handshake",
  "🏆": "Trophy",
  "🥇": "Trophy",
  "⚠️": "Warning",
  "⚠": "Warning",
  "🚧": "Warning",
  "▶️": "Play",
  "▶": "Play",
  "🖼️": "Image",
  "🖼": "Image",
  "📎": "Paperclip",
  "✅": "CheckCircle",
  "☑️": "CheckCircle",
  "☑": "CheckCircle",
  "❌": "X",
  "✖️": "X",
  "✖": "X",
  "✨": "Sparkle",
  "😊": "Smiley",
  "🎛️": "Sliders",
  "🎛": "Sliders",
  "🖱️": "Mouse",
  "🖱": "Mouse",
  "📞": "Phone",
  "☎️": "Phone",
  "☎": "Phone",
  "🌐": "Globe",
  "🌍": "Globe",
  "🌎": "Globe",
  "🌏": "Globe",
  "🏠": "House",
  "📖": "BookOpen",
  "🎯": "Target",
  "🔐": "LockKey",
  "🔒": "Lock",
  "🔓": "LockOpen",
  "🔤": "TextAa",
  "💡": "Lightbulb",
  "🚨": "Siren",
  "🎉": "Confetti",
  "🎲": "DiceFive",
  "🎓": "GraduationCap",
  "🔬": "Microscope",
  "📍": "MapPin",
  "🤖": "Robot",
  "🧬": "Dna",
  "🧠": "Brain",
  "💻": "Laptop",
  "📄": "FileText",
  "📃": "File",
  "📑": "Files",
  "🐛": "Bug",
  "🛟": "Lifebuoy",
  "🎙️": "Microphone",
  "🎙": "Microphone",
  "🎤": "Microphone",
  "📣": "Megaphone",
  "📢": "Megaphone",
  "📡": "Broadcast",
  "❓": "Question",
  "❔": "Question",
  "🔄": "ArrowsClockwise",
  "🔑": "Key",
  "🔢": "Hash",
  "⬇️": "ArrowDown",
  "⬇": "ArrowDown",
  "↗️": "ArrowUpRight",
  "↗": "ArrowUpRight",
  "🔙": "ArrowLeft",
  "↪️": "ArrowBendUpRight",
  "↪": "ArrowBendUpRight",
  "🪶": "Feather",
  "👑": "Crown",
  "🚪": "SignOut",
  "🧊": "Cube",
  "📦": "Cube",
  "✂️": "Scissors",
  "✂": "Scissors",
  "📏": "Ruler",
  "📐": "Ruler",
  "🔗": "Link",
  "🎠": "Images",
  "🎬": "FilmStrip",
  "📱": "DeviceMobile",
  "📟": "DeviceTablet",
  "🔀": "GitBranch",
  "⚖️": "Scales",
  "⚖": "Scales",
  "🧪": "TestTube",
  "🏁": "FlagCheckered",
  "🧩": "PuzzlePiece",
  "🔷": "Diamond",
  "💎": "Diamond",
  "➡️": "ArrowRight",
  "➡": "ArrowRight",
  "🧭": "Compass",
  "🧮": "Calculator",
  "🎵": "MusicNotes",
  "🎶": "MusicNotes",
  "🗜️": "FileZip",
  "🗜": "FileZip",
  "🔔": "Bell",
  "🕒": "Clock",
  "⏰": "Clock",
  "⏱️": "Clock",
  "⏱": "Clock",
  "🔧": "Wrench",
  "🛠️": "Wrench",
  "🛠": "Wrench",
  "📌": "PushPin",
  "⭐": "Star",
  "🌟": "Star",
  "🔍": "MagnifyingGlass",
  "🔎": "MagnifyingGlass",
  "🎚️": "Faders",
  "🎚": "Faders",
  "💲": "Terminal",
  "🐍": "Code",
  "☕": "Coffee",
  "💽": "FloppyDiskBack",
  "🗄️": "HardDrives",
  "🗄": "HardDrives",
  "❤️": "Heart",
  "❤": "Heart",
  "👍": "ThumbsUp",
  "📜": "ListChecks",
  "🌳": "TreeStructure",
  "📚": "BookOpen",
  "♻️": "ArrowsClockwise",
  "♻": "ArrowsClockwise",
  "🏫": "Buildings",
  "🟨": "Code",
  "🐘": "Code",
  "🐳": "Code",
  "🗃️": "HardDrives",
  "🗃": "HardDrives",
  "💥": "Lightning",
  "🧾": "ClipboardText",
  "📷": "Image"
};

export default function UiIcon({ name, className, title, size = '1.2em' }: {
  name: string;
  className?: string;
  title?: string;
  size?: number | string;
}) {
  const Icon = icons[name as keyof typeof icons] || icons[legacyNames[name]];
  if (!Icon) return <span className={className}>{name}</span>;
  return <Icon data-ui-icon={name} className={className} size={size} weight="regular" color="currentColor"
    aria-hidden={title ? undefined : true} aria-label={title} role={title ? 'img' : undefined}
    style={{ display: 'inline-block', verticalAlign: '-0.2em', flexShrink: 0 }} />;
}
